import { useTranslation } from 'react-i18next'

import { AliasAction } from '@pages/IntroducingBroker/LinkHub/Links/hooks/useAliasActions'

import { BaseModalType } from '@context/ModalsContext'

import { ListItem } from '@ui/components/List'
import { Modal } from '@ui/components/Modal'
import { PopoverList } from '@ui/components/Popover'

type AliasActionsModalProps = {
  aliasName: string
  rowNumber: number
  actions: AliasAction[]
}

export const AliasActionsModal: BaseModalType<AliasActionsModalProps> = ({
  aliasName,
  rowNumber,
  actions,
  close,
}) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>
        {t('IB.LinkHubPage.Alias')} #{rowNumber} {aliasName}
      </Modal.Header>
      <Modal.Body>
        <PopoverList>
          {actions.map(({ id, icon, label, disabled }) => (
            <ListItem
              key={id}
              startSlot={{ icon: { icon, color: 'text-med-em' }, size: 'x20' }}
              title={label}
              disabled={disabled}
              onClick={() => {
                close()
                actions.find((a) => a.id === id)?.onClick()
              }}
            />
          ))}
        </PopoverList>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
